module.exports = __webpack_public_path__ + "img/swap.714d3fe.webp";